import React from 'react'
import SpecificProduct from '../Components/Specificcrad/specificProduct'

const SpecificItemInfo = () => {
  return (
    <SpecificProduct />
  )
}

export default SpecificItemInfo